import { useEffect, useState } from 'react'
import { useSessione } from 'context/SessioneProvider'

export default function useStateConSessione(defaultValue, chiaveStorage, opzioni = {}) {
  const { rimuoviSe = false } = opzioni

  const { [chiaveStorage]: statoStorage, salvaInSessione, rimuoviDaSessione } = useSessione()

  const [stato, setStato] = useState(statoStorage ?? defaultValue)

  useEffect(() => {
    if (rimuoviSe) rimuoviDaSessione(chiaveStorage)
    else salvaInSessione(chiaveStorage, stato)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveStorage, stato, rimuoviSe])

  return [stato, setStato]
}